import {useQuery} from '@tanstack/react-query'
import {useServices} from '@/services/context'
import type {Page} from '@/types/page'
import type {IdentityLifecycleEvent} from '@/types/identity'
import {buildLifecycleEventsParams, type BaseLifecycleEventsFilters} from './lifecycle-events-params'

export const IDENTITY_LIFECYCLE_EVENTS_QUERY_KEY = 'identity-lifecycle-events'

export type IdentityLifecycleEventsFilters = BaseLifecycleEventsFilters

/**
 * Read the per-identity lifecycle timeline (spec §7.1).
 *
 * <p>Server-paginated; default sort is {@code changedAt DESC} so the latest
 * transition appears first. Pass filters to narrow by trigger-source CSV /
 * date range. The hook is enabled only when {@code identityId} is set —
 * a falsy id keeps the query idle (used on the detail page during initial
 * route resolution).
 */
export function useIdentityLifecycleEvents(
    identityId: string | undefined,
    filters: IdentityLifecycleEventsFilters = {},
) {
    const services = useServices()
    const params = buildLifecycleEventsParams(filters)
    return useQuery<Page<IdentityLifecycleEvent>>({
        queryKey: [IDENTITY_LIFECYCLE_EVENTS_QUERY_KEY, identityId, params],
        queryFn: () => services.identities.lifecycleEvents(identityId as string, params),
        enabled: Boolean(identityId),
    })
}
